/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  AssignmentModel,
  AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody,
  AssignmentViewModel,
  BasicCaseModel,
  CarKeyPhotoRequest,
  CarParkPhotoRequest,
  CaseAddCarKeyPhotoParams,
  CaseAddCaseAssignmentPhotoParams,
  CaseAddCaseAssignmentPositionsParams,
  CaseAddOrUpdateCommentParams,
  CaseApproveCaseRequestParams,
  CaseAssignmentEventModel,
  CaseAssignmentGPSData,
  CaseCloseCaseParams,
  CaseCommentLogDTO,
  CaseDeleteCaseParams,
  CaseDeleteCommentParams,
  CaseDenyCaseRequestParams,
  CaseExtendedModel,
  CaseGetAssignmentOverlapsFromIds200Five,
  CaseGetAssignmentOverlapsFromIds200Four,
  CaseGetAssignmentOverlapsFromIds200One,
  CaseGetAssignmentOverlapsFromIds200Three,
  CaseGetAssignmentOverlapsFromIds200Two,
  CaseGetCaseParams,
  CaseGetCasesByRideOrderIdParams,
  CaseGetCommentHistoryParams,
  CaseGetMostRecentClosedCasesParams,
  CaseGetRecentDuplicateCaseParams,
  CaseMakeCaseAssignmentRequestParams,
  CaseModel,
  CaseModelBody,
  CaseTranslateCommentParams,
  CaseUpdateCaseParams,
  EventModelWithMissingGearInfo,
  GeolocationModel,
  GeolocationModelBody,
  GetAllCasesRequest,
  RecentDuplicateCaseResult,
  TranslateCommentResponse,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useCaseCreateCaseHook = () => {
  const caseCreateCase = useCustomInstance<number>();

  return useCallback(
    (caseModelBody: CaseModelBody) => {
      return caseCreateCase({
        url: `/api/Case/CreateCase`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: caseModelBody,
      });
    },
    [caseCreateCase]
  );
};

export const useCaseCreateCaseMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseCreateCaseHook>>>,
    TError,
    { data: CaseModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseCreateCaseHook>>>,
  TError,
  { data: CaseModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseCreateCase = useCaseCreateCaseHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseCreateCaseHook>>>,
    { data: CaseModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return caseCreateCase(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseCreateCaseMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseCreateCaseHook>>>
>;
export type CaseCreateCaseMutationBody = CaseModelBody;
export type CaseCreateCaseMutationError = unknown;

export const useCaseCreateCase = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseCreateCaseHook>>>,
    TError,
    { data: CaseModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseCreateCaseHook>>>,
  TError,
  { data: CaseModelBody },
  TContext
> => {
  const mutationOptions = useCaseCreateCaseMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseUpdateCaseHook = () => {
  const caseUpdateCase = useCustomInstance<void>();

  return useCallback(
    (caseModelBody: CaseModelBody, params?: CaseUpdateCaseParams) => {
      return caseUpdateCase({
        url: `/api/Case/UpdateCase`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: caseModelBody,
        params,
      });
    },
    [caseUpdateCase]
  );
};

export const useCaseUpdateCaseMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseUpdateCaseHook>>>,
    TError,
    { data: CaseModelBody; params?: CaseUpdateCaseParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseUpdateCaseHook>>>,
  TError,
  { data: CaseModelBody; params?: CaseUpdateCaseParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseUpdateCase = useCaseUpdateCaseHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseUpdateCaseHook>>>,
    { data: CaseModelBody; params?: CaseUpdateCaseParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return caseUpdateCase(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseUpdateCaseMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseUpdateCaseHook>>>
>;
export type CaseUpdateCaseMutationBody = CaseModelBody;
export type CaseUpdateCaseMutationError = unknown;

export const useCaseUpdateCase = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseUpdateCaseHook>>>,
    TError,
    { data: CaseModelBody; params?: CaseUpdateCaseParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseUpdateCaseHook>>>,
  TError,
  { data: CaseModelBody; params?: CaseUpdateCaseParams },
  TContext
> => {
  const mutationOptions = useCaseUpdateCaseMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseGetCaseOverlapsHook = () => {
  const caseGetCaseOverlaps = useCustomInstance<CaseModel[]>();

  return useCallback(
    (caseModelBody: CaseModelBody) => {
      return caseGetCaseOverlaps({
        url: `/api/Case/GetCaseOverlaps`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: caseModelBody,
      });
    },
    [caseGetCaseOverlaps]
  );
};

export const useCaseGetCaseOverlapsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseGetCaseOverlapsHook>>>,
    TError,
    { data: CaseModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseGetCaseOverlapsHook>>>,
  TError,
  { data: CaseModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseGetCaseOverlaps = useCaseGetCaseOverlapsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseGetCaseOverlapsHook>>>,
    { data: CaseModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return caseGetCaseOverlaps(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseGetCaseOverlapsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseGetCaseOverlapsHook>>>
>;
export type CaseGetCaseOverlapsMutationBody = CaseModelBody;
export type CaseGetCaseOverlapsMutationError = unknown;

export const useCaseGetCaseOverlaps = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseGetCaseOverlapsHook>>>,
    TError,
    { data: CaseModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseGetCaseOverlapsHook>>>,
  TError,
  { data: CaseModelBody },
  TContext
> => {
  const mutationOptions = useCaseGetCaseOverlapsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseGetAssignmentOverlapsFromIdsHook = () => {
  const caseGetAssignmentOverlapsFromIds = useCustomInstance<
    | CaseGetAssignmentOverlapsFromIds200One
    | CaseGetAssignmentOverlapsFromIds200Two
    | CaseGetAssignmentOverlapsFromIds200Three
    | CaseGetAssignmentOverlapsFromIds200Four
    | CaseGetAssignmentOverlapsFromIds200Five
  >();

  return useCallback(
    (
      assignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody
    ) => {
      return caseGetAssignmentOverlapsFromIds({
        url: `/api/Case/GetAssignmentOverlapsFromIds`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: assignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody,
      });
    },
    [caseGetAssignmentOverlapsFromIds]
  );
};

export const useCaseGetAssignmentOverlapsFromIdsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCaseGetAssignmentOverlapsFromIdsHook>>
    >,
    TError,
    {
      data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useCaseGetAssignmentOverlapsFromIdsHook>>
  >,
  TError,
  { data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseGetAssignmentOverlapsFromIds =
    useCaseGetAssignmentOverlapsFromIdsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useCaseGetAssignmentOverlapsFromIdsHook>>
    >,
    { data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody }
  > = (props) => {
    const { data } = props ?? {};

    return caseGetAssignmentOverlapsFromIds(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseGetAssignmentOverlapsFromIdsMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useCaseGetAssignmentOverlapsFromIdsHook>>
  >
>;
export type CaseGetAssignmentOverlapsFromIdsMutationBody =
  AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody;
export type CaseGetAssignmentOverlapsFromIdsMutationError = unknown;

export const useCaseGetAssignmentOverlapsFromIds = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCaseGetAssignmentOverlapsFromIdsHook>>
    >,
    TError,
    {
      data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useCaseGetAssignmentOverlapsFromIdsHook>>
  >,
  TError,
  { data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody },
  TContext
> => {
  const mutationOptions =
    useCaseGetAssignmentOverlapsFromIdsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseGetAssignmentOverlapsHook = () => {
  const caseGetAssignmentOverlaps = useCustomInstance<AssignmentViewModel[]>();

  return useCallback(
    (assignmentModel: AssignmentModel) => {
      return caseGetAssignmentOverlaps({
        url: `/api/Case/GetAssignmentOverlaps`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: assignmentModel,
      });
    },
    [caseGetAssignmentOverlaps]
  );
};

export const useCaseGetAssignmentOverlapsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseGetAssignmentOverlapsHook>>>,
    TError,
    { data: AssignmentModel },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseGetAssignmentOverlapsHook>>>,
  TError,
  { data: AssignmentModel },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseGetAssignmentOverlaps = useCaseGetAssignmentOverlapsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseGetAssignmentOverlapsHook>>>,
    { data: AssignmentModel }
  > = (props) => {
    const { data } = props ?? {};

    return caseGetAssignmentOverlaps(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseGetAssignmentOverlapsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseGetAssignmentOverlapsHook>>>
>;
export type CaseGetAssignmentOverlapsMutationBody = AssignmentModel;
export type CaseGetAssignmentOverlapsMutationError = unknown;

export const useCaseGetAssignmentOverlaps = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseGetAssignmentOverlapsHook>>>,
    TError,
    { data: AssignmentModel },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseGetAssignmentOverlapsHook>>>,
  TError,
  { data: AssignmentModel },
  TContext
> => {
  const mutationOptions = useCaseGetAssignmentOverlapsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseGetCasesByRideOrderIdHook = () => {
  const caseGetCasesByRideOrderId = useCustomInstance<CaseModel[]>();

  return useCallback(
    (params?: CaseGetCasesByRideOrderIdParams) => {
      return caseGetCasesByRideOrderId({
        url: `/api/Case/GetCasesByRideOrderId`,
        method: 'POST',
        params,
      });
    },
    [caseGetCasesByRideOrderId]
  );
};

export const useCaseGetCasesByRideOrderIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseGetCasesByRideOrderIdHook>>>,
    TError,
    { params?: CaseGetCasesByRideOrderIdParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseGetCasesByRideOrderIdHook>>>,
  TError,
  { params?: CaseGetCasesByRideOrderIdParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseGetCasesByRideOrderId = useCaseGetCasesByRideOrderIdHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseGetCasesByRideOrderIdHook>>>,
    { params?: CaseGetCasesByRideOrderIdParams }
  > = (props) => {
    const { params } = props ?? {};

    return caseGetCasesByRideOrderId(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseGetCasesByRideOrderIdMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseGetCasesByRideOrderIdHook>>>
>;

export type CaseGetCasesByRideOrderIdMutationError = unknown;

export const useCaseGetCasesByRideOrderId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseGetCasesByRideOrderIdHook>>>,
    TError,
    { params?: CaseGetCasesByRideOrderIdParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseGetCasesByRideOrderIdHook>>>,
  TError,
  { params?: CaseGetCasesByRideOrderIdParams },
  TContext
> => {
  const mutationOptions = useCaseGetCasesByRideOrderIdMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseGetCaseHook = () => {
  const caseGetCase = useCustomInstance<CaseExtendedModel>();

  return useCallback(
    (params?: CaseGetCaseParams) => {
      return caseGetCase({ url: `/api/Case/GetCase`, method: 'POST', params });
    },
    [caseGetCase]
  );
};

export const useCaseGetCaseMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseGetCaseHook>>>,
    TError,
    { params?: CaseGetCaseParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseGetCaseHook>>>,
  TError,
  { params?: CaseGetCaseParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseGetCase = useCaseGetCaseHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseGetCaseHook>>>,
    { params?: CaseGetCaseParams }
  > = (props) => {
    const { params } = props ?? {};

    return caseGetCase(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseGetCaseMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseGetCaseHook>>>
>;

export type CaseGetCaseMutationError = unknown;

export const useCaseGetCase = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseGetCaseHook>>>,
    TError,
    { params?: CaseGetCaseParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseGetCaseHook>>>,
  TError,
  { params?: CaseGetCaseParams },
  TContext
> => {
  const mutationOptions = useCaseGetCaseMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseAddOrUpdateCommentHook = () => {
  const caseAddOrUpdateComment = useCustomInstance<void>();

  return useCallback(
    (params?: CaseAddOrUpdateCommentParams) => {
      return caseAddOrUpdateComment({
        url: `/api/Case/AddOrUpdateComment`,
        method: 'POST',
        params,
      });
    },
    [caseAddOrUpdateComment]
  );
};

export const useCaseAddOrUpdateCommentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseAddOrUpdateCommentHook>>>,
    TError,
    { params?: CaseAddOrUpdateCommentParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseAddOrUpdateCommentHook>>>,
  TError,
  { params?: CaseAddOrUpdateCommentParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseAddOrUpdateComment = useCaseAddOrUpdateCommentHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseAddOrUpdateCommentHook>>>,
    { params?: CaseAddOrUpdateCommentParams }
  > = (props) => {
    const { params } = props ?? {};

    return caseAddOrUpdateComment(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseAddOrUpdateCommentMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseAddOrUpdateCommentHook>>>
>;

export type CaseAddOrUpdateCommentMutationError = unknown;

export const useCaseAddOrUpdateComment = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseAddOrUpdateCommentHook>>>,
    TError,
    { params?: CaseAddOrUpdateCommentParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseAddOrUpdateCommentHook>>>,
  TError,
  { params?: CaseAddOrUpdateCommentParams },
  TContext
> => {
  const mutationOptions = useCaseAddOrUpdateCommentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseGetCommentHistoryHook = () => {
  const caseGetCommentHistory = useCustomInstance<CaseCommentLogDTO[]>();

  return useCallback(
    (params?: CaseGetCommentHistoryParams, signal?: AbortSignal) => {
      return caseGetCommentHistory({
        url: `/api/Case/GetCommentHistory`,
        method: 'GET',
        params,
        signal,
      });
    },
    [caseGetCommentHistory]
  );
};

export const getCaseGetCommentHistoryQueryKey = (
  params?: CaseGetCommentHistoryParams
) => {
  return [`/api/Case/GetCommentHistory`, ...(params ? [params] : [])] as const;
};

export const useCaseGetCommentHistoryQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useCaseGetCommentHistoryHook>>>,
  TError = unknown,
>(
  params?: CaseGetCommentHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useCaseGetCommentHistoryHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCaseGetCommentHistoryQueryKey(params);

  const caseGetCommentHistory = useCaseGetCommentHistoryHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseGetCommentHistoryHook>>>
  > = ({ signal }) => caseGetCommentHistory(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseGetCommentHistoryHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CaseGetCommentHistoryQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseGetCommentHistoryHook>>>
>;
export type CaseGetCommentHistoryQueryError = unknown;

export const useCaseGetCommentHistory = <
  TData = Awaited<ReturnType<ReturnType<typeof useCaseGetCommentHistoryHook>>>,
  TError = unknown,
>(
  params?: CaseGetCommentHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useCaseGetCommentHistoryHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useCaseGetCommentHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useCaseTranslateCommentHook = () => {
  const caseTranslateComment = useCustomInstance<TranslateCommentResponse>();

  return useCallback(
    (params?: CaseTranslateCommentParams) => {
      return caseTranslateComment({
        url: `/api/Case/TranslateComment`,
        method: 'POST',
        params,
      });
    },
    [caseTranslateComment]
  );
};

export const useCaseTranslateCommentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseTranslateCommentHook>>>,
    TError,
    { params?: CaseTranslateCommentParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseTranslateCommentHook>>>,
  TError,
  { params?: CaseTranslateCommentParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseTranslateComment = useCaseTranslateCommentHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseTranslateCommentHook>>>,
    { params?: CaseTranslateCommentParams }
  > = (props) => {
    const { params } = props ?? {};

    return caseTranslateComment(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseTranslateCommentMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseTranslateCommentHook>>>
>;

export type CaseTranslateCommentMutationError = unknown;

export const useCaseTranslateComment = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseTranslateCommentHook>>>,
    TError,
    { params?: CaseTranslateCommentParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseTranslateCommentHook>>>,
  TError,
  { params?: CaseTranslateCommentParams },
  TContext
> => {
  const mutationOptions = useCaseTranslateCommentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseMarkEventsAsReadByAdminHook = () => {
  const caseMarkEventsAsReadByAdmin = useCustomInstance<void>();

  return useCallback(
    (
      assignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody
    ) => {
      return caseMarkEventsAsReadByAdmin({
        url: `/api/Case/MarkEventsAsReadByAdmin`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: assignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody,
      });
    },
    [caseMarkEventsAsReadByAdmin]
  );
};

export const useCaseMarkEventsAsReadByAdminMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseMarkEventsAsReadByAdminHook>>>,
    TError,
    {
      data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseMarkEventsAsReadByAdminHook>>>,
  TError,
  { data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseMarkEventsAsReadByAdmin = useCaseMarkEventsAsReadByAdminHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseMarkEventsAsReadByAdminHook>>>,
    { data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody }
  > = (props) => {
    const { data } = props ?? {};

    return caseMarkEventsAsReadByAdmin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseMarkEventsAsReadByAdminMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseMarkEventsAsReadByAdminHook>>>
>;
export type CaseMarkEventsAsReadByAdminMutationBody =
  AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody;
export type CaseMarkEventsAsReadByAdminMutationError = unknown;

export const useCaseMarkEventsAsReadByAdmin = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseMarkEventsAsReadByAdminHook>>>,
    TError,
    {
      data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseMarkEventsAsReadByAdminHook>>>,
  TError,
  { data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody },
  TContext
> => {
  const mutationOptions =
    useCaseMarkEventsAsReadByAdminMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @deprecated
 */
export const useCaseAddCaseAssignmentPositionsHook = () => {
  const caseAddCaseAssignmentPositions = useCustomInstance<boolean>();

  return useCallback(
    (
      geolocationModel: GeolocationModel[],
      params?: CaseAddCaseAssignmentPositionsParams
    ) => {
      return caseAddCaseAssignmentPositions({
        url: `/api/Case/AddCaseAssignmentPositions`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: geolocationModel,
        params,
      });
    },
    [caseAddCaseAssignmentPositions]
  );
};

export const useCaseAddCaseAssignmentPositionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCaseAddCaseAssignmentPositionsHook>>
    >,
    TError,
    { data: GeolocationModel[]; params?: CaseAddCaseAssignmentPositionsParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseAddCaseAssignmentPositionsHook>>>,
  TError,
  { data: GeolocationModel[]; params?: CaseAddCaseAssignmentPositionsParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseAddCaseAssignmentPositions =
    useCaseAddCaseAssignmentPositionsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useCaseAddCaseAssignmentPositionsHook>>
    >,
    { data: GeolocationModel[]; params?: CaseAddCaseAssignmentPositionsParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return caseAddCaseAssignmentPositions(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseAddCaseAssignmentPositionsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseAddCaseAssignmentPositionsHook>>>
>;
export type CaseAddCaseAssignmentPositionsMutationBody = GeolocationModel[];
export type CaseAddCaseAssignmentPositionsMutationError = unknown;

/**
 * @deprecated
 */
export const useCaseAddCaseAssignmentPositions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCaseAddCaseAssignmentPositionsHook>>
    >,
    TError,
    { data: GeolocationModel[]; params?: CaseAddCaseAssignmentPositionsParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseAddCaseAssignmentPositionsHook>>>,
  TError,
  { data: GeolocationModel[]; params?: CaseAddCaseAssignmentPositionsParams },
  TContext
> => {
  const mutationOptions =
    useCaseAddCaseAssignmentPositionsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseAddCaseAssignmentGPSDataHook = () => {
  const caseAddCaseAssignmentGPSData = useCustomInstance<boolean>();

  return useCallback(
    (caseAssignmentGPSData: CaseAssignmentGPSData[]) => {
      return caseAddCaseAssignmentGPSData({
        url: `/api/Case/AddCaseAssignmentGPSData`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: caseAssignmentGPSData,
      });
    },
    [caseAddCaseAssignmentGPSData]
  );
};

export const useCaseAddCaseAssignmentGPSDataMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseAddCaseAssignmentGPSDataHook>>>,
    TError,
    { data: CaseAssignmentGPSData[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseAddCaseAssignmentGPSDataHook>>>,
  TError,
  { data: CaseAssignmentGPSData[] },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseAddCaseAssignmentGPSData = useCaseAddCaseAssignmentGPSDataHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseAddCaseAssignmentGPSDataHook>>>,
    { data: CaseAssignmentGPSData[] }
  > = (props) => {
    const { data } = props ?? {};

    return caseAddCaseAssignmentGPSData(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseAddCaseAssignmentGPSDataMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseAddCaseAssignmentGPSDataHook>>>
>;
export type CaseAddCaseAssignmentGPSDataMutationBody = CaseAssignmentGPSData[];
export type CaseAddCaseAssignmentGPSDataMutationError = unknown;

export const useCaseAddCaseAssignmentGPSData = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseAddCaseAssignmentGPSDataHook>>>,
    TError,
    { data: CaseAssignmentGPSData[] },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseAddCaseAssignmentGPSDataHook>>>,
  TError,
  { data: CaseAssignmentGPSData[] },
  TContext
> => {
  const mutationOptions =
    useCaseAddCaseAssignmentGPSDataMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseAddCaseAssignmentPhotoHook = () => {
  const caseAddCaseAssignmentPhoto = useCustomInstance<void>();

  return useCallback(
    (params?: CaseAddCaseAssignmentPhotoParams) => {
      return caseAddCaseAssignmentPhoto({
        url: `/api/Case/AddCaseAssignmentPhoto`,
        method: 'POST',
        params,
      });
    },
    [caseAddCaseAssignmentPhoto]
  );
};

export const useCaseAddCaseAssignmentPhotoMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseAddCaseAssignmentPhotoHook>>>,
    TError,
    { params?: CaseAddCaseAssignmentPhotoParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseAddCaseAssignmentPhotoHook>>>,
  TError,
  { params?: CaseAddCaseAssignmentPhotoParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseAddCaseAssignmentPhoto = useCaseAddCaseAssignmentPhotoHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseAddCaseAssignmentPhotoHook>>>,
    { params?: CaseAddCaseAssignmentPhotoParams }
  > = (props) => {
    const { params } = props ?? {};

    return caseAddCaseAssignmentPhoto(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseAddCaseAssignmentPhotoMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseAddCaseAssignmentPhotoHook>>>
>;

export type CaseAddCaseAssignmentPhotoMutationError = unknown;

export const useCaseAddCaseAssignmentPhoto = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseAddCaseAssignmentPhotoHook>>>,
    TError,
    { params?: CaseAddCaseAssignmentPhotoParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseAddCaseAssignmentPhotoHook>>>,
  TError,
  { params?: CaseAddCaseAssignmentPhotoParams },
  TContext
> => {
  const mutationOptions = useCaseAddCaseAssignmentPhotoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseAddCarKeyPhotoHook = () => {
  const caseAddCarKeyPhoto = useCustomInstance<void>();

  return useCallback(
    (params?: CaseAddCarKeyPhotoParams) => {
      return caseAddCarKeyPhoto({
        url: `/api/Case/AddCarKeyPhoto`,
        method: 'POST',
        params,
      });
    },
    [caseAddCarKeyPhoto]
  );
};

export const useCaseAddCarKeyPhotoMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseAddCarKeyPhotoHook>>>,
    TError,
    { params?: CaseAddCarKeyPhotoParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseAddCarKeyPhotoHook>>>,
  TError,
  { params?: CaseAddCarKeyPhotoParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseAddCarKeyPhoto = useCaseAddCarKeyPhotoHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseAddCarKeyPhotoHook>>>,
    { params?: CaseAddCarKeyPhotoParams }
  > = (props) => {
    const { params } = props ?? {};

    return caseAddCarKeyPhoto(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseAddCarKeyPhotoMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseAddCarKeyPhotoHook>>>
>;

export type CaseAddCarKeyPhotoMutationError = unknown;

export const useCaseAddCarKeyPhoto = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseAddCarKeyPhotoHook>>>,
    TError,
    { params?: CaseAddCarKeyPhotoParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseAddCarKeyPhotoHook>>>,
  TError,
  { params?: CaseAddCarKeyPhotoParams },
  TContext
> => {
  const mutationOptions = useCaseAddCarKeyPhotoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseAddCarKeyPhotoWithGeolocationHook = () => {
  const caseAddCarKeyPhotoWithGeolocation = useCustomInstance<void>();

  return useCallback(
    (carKeyPhotoRequest: CarKeyPhotoRequest) => {
      return caseAddCarKeyPhotoWithGeolocation({
        url: `/api/Case/AddCarKeyPhotoWithGeolocation`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: carKeyPhotoRequest,
      });
    },
    [caseAddCarKeyPhotoWithGeolocation]
  );
};

export const useCaseAddCarKeyPhotoWithGeolocationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCaseAddCarKeyPhotoWithGeolocationHook>>
    >,
    TError,
    { data: CarKeyPhotoRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useCaseAddCarKeyPhotoWithGeolocationHook>>
  >,
  TError,
  { data: CarKeyPhotoRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseAddCarKeyPhotoWithGeolocation =
    useCaseAddCarKeyPhotoWithGeolocationHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useCaseAddCarKeyPhotoWithGeolocationHook>>
    >,
    { data: CarKeyPhotoRequest }
  > = (props) => {
    const { data } = props ?? {};

    return caseAddCarKeyPhotoWithGeolocation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseAddCarKeyPhotoWithGeolocationMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useCaseAddCarKeyPhotoWithGeolocationHook>>
  >
>;
export type CaseAddCarKeyPhotoWithGeolocationMutationBody = CarKeyPhotoRequest;
export type CaseAddCarKeyPhotoWithGeolocationMutationError = unknown;

export const useCaseAddCarKeyPhotoWithGeolocation = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCaseAddCarKeyPhotoWithGeolocationHook>>
    >,
    TError,
    { data: CarKeyPhotoRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useCaseAddCarKeyPhotoWithGeolocationHook>>
  >,
  TError,
  { data: CarKeyPhotoRequest },
  TContext
> => {
  const mutationOptions =
    useCaseAddCarKeyPhotoWithGeolocationMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseAddCarParkPhotoWithGeolocationHook = () => {
  const caseAddCarParkPhotoWithGeolocation = useCustomInstance<void>();

  return useCallback(
    (carParkPhotoRequest: CarParkPhotoRequest) => {
      return caseAddCarParkPhotoWithGeolocation({
        url: `/api/Case/AddCarParkPhotoWithGeolocation`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: carParkPhotoRequest,
      });
    },
    [caseAddCarParkPhotoWithGeolocation]
  );
};

export const useCaseAddCarParkPhotoWithGeolocationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCaseAddCarParkPhotoWithGeolocationHook>>
    >,
    TError,
    { data: CarParkPhotoRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useCaseAddCarParkPhotoWithGeolocationHook>>
  >,
  TError,
  { data: CarParkPhotoRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseAddCarParkPhotoWithGeolocation =
    useCaseAddCarParkPhotoWithGeolocationHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useCaseAddCarParkPhotoWithGeolocationHook>>
    >,
    { data: CarParkPhotoRequest }
  > = (props) => {
    const { data } = props ?? {};

    return caseAddCarParkPhotoWithGeolocation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseAddCarParkPhotoWithGeolocationMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useCaseAddCarParkPhotoWithGeolocationHook>>
  >
>;
export type CaseAddCarParkPhotoWithGeolocationMutationBody =
  CarParkPhotoRequest;
export type CaseAddCarParkPhotoWithGeolocationMutationError = unknown;

export const useCaseAddCarParkPhotoWithGeolocation = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCaseAddCarParkPhotoWithGeolocationHook>>
    >,
    TError,
    { data: CarParkPhotoRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useCaseAddCarParkPhotoWithGeolocationHook>>
  >,
  TError,
  { data: CarParkPhotoRequest },
  TContext
> => {
  const mutationOptions =
    useCaseAddCarParkPhotoWithGeolocationMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseDeleteCaseHook = () => {
  const caseDeleteCase = useCustomInstance<void>();

  return useCallback(
    (params?: CaseDeleteCaseParams) => {
      return caseDeleteCase({
        url: `/api/Case/DeleteCase`,
        method: 'DELETE',
        params,
      });
    },
    [caseDeleteCase]
  );
};

export const useCaseDeleteCaseMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseDeleteCaseHook>>>,
    TError,
    { params?: CaseDeleteCaseParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseDeleteCaseHook>>>,
  TError,
  { params?: CaseDeleteCaseParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseDeleteCase = useCaseDeleteCaseHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseDeleteCaseHook>>>,
    { params?: CaseDeleteCaseParams }
  > = (props) => {
    const { params } = props ?? {};

    return caseDeleteCase(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseDeleteCaseMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseDeleteCaseHook>>>
>;

export type CaseDeleteCaseMutationError = unknown;

export const useCaseDeleteCase = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseDeleteCaseHook>>>,
    TError,
    { params?: CaseDeleteCaseParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseDeleteCaseHook>>>,
  TError,
  { params?: CaseDeleteCaseParams },
  TContext
> => {
  const mutationOptions = useCaseDeleteCaseMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseDeleteCommentHook = () => {
  const caseDeleteComment = useCustomInstance<void>();

  return useCallback(
    (params?: CaseDeleteCommentParams) => {
      return caseDeleteComment({
        url: `/api/Case/DeleteComment`,
        method: 'DELETE',
        params,
      });
    },
    [caseDeleteComment]
  );
};

export const useCaseDeleteCommentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseDeleteCommentHook>>>,
    TError,
    { params?: CaseDeleteCommentParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseDeleteCommentHook>>>,
  TError,
  { params?: CaseDeleteCommentParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseDeleteComment = useCaseDeleteCommentHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseDeleteCommentHook>>>,
    { params?: CaseDeleteCommentParams }
  > = (props) => {
    const { params } = props ?? {};

    return caseDeleteComment(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseDeleteCommentMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseDeleteCommentHook>>>
>;

export type CaseDeleteCommentMutationError = unknown;

export const useCaseDeleteComment = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseDeleteCommentHook>>>,
    TError,
    { params?: CaseDeleteCommentParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseDeleteCommentHook>>>,
  TError,
  { params?: CaseDeleteCommentParams },
  TContext
> => {
  const mutationOptions = useCaseDeleteCommentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseCloseCaseHook = () => {
  const caseCloseCase = useCustomInstance<void>();

  return useCallback(
    (params?: CaseCloseCaseParams) => {
      return caseCloseCase({
        url: `/api/Case/CloseCase`,
        method: 'POST',
        params,
      });
    },
    [caseCloseCase]
  );
};

export const useCaseCloseCaseMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseCloseCaseHook>>>,
    TError,
    { params?: CaseCloseCaseParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseCloseCaseHook>>>,
  TError,
  { params?: CaseCloseCaseParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseCloseCase = useCaseCloseCaseHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseCloseCaseHook>>>,
    { params?: CaseCloseCaseParams }
  > = (props) => {
    const { params } = props ?? {};

    return caseCloseCase(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseCloseCaseMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseCloseCaseHook>>>
>;

export type CaseCloseCaseMutationError = unknown;

export const useCaseCloseCase = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseCloseCaseHook>>>,
    TError,
    { params?: CaseCloseCaseParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseCloseCaseHook>>>,
  TError,
  { params?: CaseCloseCaseParams },
  TContext
> => {
  const mutationOptions = useCaseCloseCaseMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseMakeCaseAssignmentRequestHook = () => {
  const caseMakeCaseAssignmentRequest = useCustomInstance<Blob>();

  return useCallback(
    (
      geolocationModelBody: GeolocationModelBody,
      params?: CaseMakeCaseAssignmentRequestParams
    ) => {
      return caseMakeCaseAssignmentRequest({
        url: `/api/Case/MakeCaseAssignmentRequest`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: geolocationModelBody,
        params,
        responseType: 'blob',
      });
    },
    [caseMakeCaseAssignmentRequest]
  );
};

export const useCaseMakeCaseAssignmentRequestMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCaseMakeCaseAssignmentRequestHook>>
    >,
    TError,
    {
      data: GeolocationModelBody;
      params?: CaseMakeCaseAssignmentRequestParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseMakeCaseAssignmentRequestHook>>>,
  TError,
  { data: GeolocationModelBody; params?: CaseMakeCaseAssignmentRequestParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseMakeCaseAssignmentRequest = useCaseMakeCaseAssignmentRequestHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useCaseMakeCaseAssignmentRequestHook>>
    >,
    { data: GeolocationModelBody; params?: CaseMakeCaseAssignmentRequestParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return caseMakeCaseAssignmentRequest(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseMakeCaseAssignmentRequestMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseMakeCaseAssignmentRequestHook>>>
>;
export type CaseMakeCaseAssignmentRequestMutationBody = GeolocationModelBody;
export type CaseMakeCaseAssignmentRequestMutationError = unknown;

export const useCaseMakeCaseAssignmentRequest = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCaseMakeCaseAssignmentRequestHook>>
    >,
    TError,
    {
      data: GeolocationModelBody;
      params?: CaseMakeCaseAssignmentRequestParams;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseMakeCaseAssignmentRequestHook>>>,
  TError,
  { data: GeolocationModelBody; params?: CaseMakeCaseAssignmentRequestParams },
  TContext
> => {
  const mutationOptions =
    useCaseMakeCaseAssignmentRequestMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseGetCaseAssignmentRequestsCountHook = () => {
  const caseGetCaseAssignmentRequestsCount = useCustomInstance<number>();

  return useCallback(
    (signal?: AbortSignal) => {
      return caseGetCaseAssignmentRequestsCount({
        url: `/api/Case/GetCaseAssignmentRequestsCount`,
        method: 'GET',
        signal,
      });
    },
    [caseGetCaseAssignmentRequestsCount]
  );
};

export const getCaseGetCaseAssignmentRequestsCountQueryKey = () => {
  return [`/api/Case/GetCaseAssignmentRequestsCount`] as const;
};

export const useCaseGetCaseAssignmentRequestsCountQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useCaseGetCaseAssignmentRequestsCountHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCaseGetCaseAssignmentRequestsCountHook>>
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCaseGetCaseAssignmentRequestsCountQueryKey();

  const caseGetCaseAssignmentRequestsCount =
    useCaseGetCaseAssignmentRequestsCountHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useCaseGetCaseAssignmentRequestsCountHook>>
    >
  > = ({ signal }) => caseGetCaseAssignmentRequestsCount(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCaseGetCaseAssignmentRequestsCountHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CaseGetCaseAssignmentRequestsCountQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useCaseGetCaseAssignmentRequestsCountHook>>
  >
>;
export type CaseGetCaseAssignmentRequestsCountQueryError = unknown;

export const useCaseGetCaseAssignmentRequestsCount = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useCaseGetCaseAssignmentRequestsCountHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCaseGetCaseAssignmentRequestsCountHook>>
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useCaseGetCaseAssignmentRequestsCountQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useCaseGetCaseAssignmentRequestsHook = () => {
  const caseGetCaseAssignmentRequests =
    useCustomInstance<CaseAssignmentEventModel[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return caseGetCaseAssignmentRequests({
        url: `/api/Case/GetCaseAssignmentRequests`,
        method: 'GET',
        signal,
      });
    },
    [caseGetCaseAssignmentRequests]
  );
};

export const getCaseGetCaseAssignmentRequestsQueryKey = () => {
  return [`/api/Case/GetCaseAssignmentRequests`] as const;
};

export const useCaseGetCaseAssignmentRequestsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useCaseGetCaseAssignmentRequestsHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCaseGetCaseAssignmentRequestsHook>>
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCaseGetCaseAssignmentRequestsQueryKey();

  const caseGetCaseAssignmentRequests = useCaseGetCaseAssignmentRequestsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseGetCaseAssignmentRequestsHook>>>
  > = ({ signal }) => caseGetCaseAssignmentRequests(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCaseGetCaseAssignmentRequestsHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CaseGetCaseAssignmentRequestsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseGetCaseAssignmentRequestsHook>>>
>;
export type CaseGetCaseAssignmentRequestsQueryError = unknown;

export const useCaseGetCaseAssignmentRequests = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useCaseGetCaseAssignmentRequestsHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCaseGetCaseAssignmentRequestsHook>>
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useCaseGetCaseAssignmentRequestsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useCaseDenyCaseRequestHook = () => {
  const caseDenyCaseRequest = useCustomInstance<Blob>();

  return useCallback(
    (params?: CaseDenyCaseRequestParams) => {
      return caseDenyCaseRequest({
        url: `/api/Case/DenyCaseRequest`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [caseDenyCaseRequest]
  );
};

export const useCaseDenyCaseRequestMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseDenyCaseRequestHook>>>,
    TError,
    { params?: CaseDenyCaseRequestParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseDenyCaseRequestHook>>>,
  TError,
  { params?: CaseDenyCaseRequestParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseDenyCaseRequest = useCaseDenyCaseRequestHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseDenyCaseRequestHook>>>,
    { params?: CaseDenyCaseRequestParams }
  > = (props) => {
    const { params } = props ?? {};

    return caseDenyCaseRequest(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseDenyCaseRequestMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseDenyCaseRequestHook>>>
>;

export type CaseDenyCaseRequestMutationError = unknown;

export const useCaseDenyCaseRequest = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseDenyCaseRequestHook>>>,
    TError,
    { params?: CaseDenyCaseRequestParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseDenyCaseRequestHook>>>,
  TError,
  { params?: CaseDenyCaseRequestParams },
  TContext
> => {
  const mutationOptions = useCaseDenyCaseRequestMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseApproveCaseRequestHook = () => {
  const caseApproveCaseRequest = useCustomInstance<Blob>();

  return useCallback(
    (params?: CaseApproveCaseRequestParams) => {
      return caseApproveCaseRequest({
        url: `/api/Case/ApproveCaseRequest`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [caseApproveCaseRequest]
  );
};

export const useCaseApproveCaseRequestMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseApproveCaseRequestHook>>>,
    TError,
    { params?: CaseApproveCaseRequestParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseApproveCaseRequestHook>>>,
  TError,
  { params?: CaseApproveCaseRequestParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseApproveCaseRequest = useCaseApproveCaseRequestHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseApproveCaseRequestHook>>>,
    { params?: CaseApproveCaseRequestParams }
  > = (props) => {
    const { params } = props ?? {};

    return caseApproveCaseRequest(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseApproveCaseRequestMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseApproveCaseRequestHook>>>
>;

export type CaseApproveCaseRequestMutationError = unknown;

export const useCaseApproveCaseRequest = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseApproveCaseRequestHook>>>,
    TError,
    { params?: CaseApproveCaseRequestParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseApproveCaseRequestHook>>>,
  TError,
  { params?: CaseApproveCaseRequestParams },
  TContext
> => {
  const mutationOptions = useCaseApproveCaseRequestMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseGetMyLastWorkGearReportHook = () => {
  const caseGetMyLastWorkGearReport =
    useCustomInstance<EventModelWithMissingGearInfo>();

  return useCallback(
    (signal?: AbortSignal) => {
      return caseGetMyLastWorkGearReport({
        url: `/api/Case/GetMyLastWorkGearReport`,
        method: 'GET',
        signal,
      });
    },
    [caseGetMyLastWorkGearReport]
  );
};

export const getCaseGetMyLastWorkGearReportQueryKey = () => {
  return [`/api/Case/GetMyLastWorkGearReport`] as const;
};

export const useCaseGetMyLastWorkGearReportQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useCaseGetMyLastWorkGearReportHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseGetMyLastWorkGearReportHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCaseGetMyLastWorkGearReportQueryKey();

  const caseGetMyLastWorkGearReport = useCaseGetMyLastWorkGearReportHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseGetMyLastWorkGearReportHook>>>
  > = ({ signal }) => caseGetMyLastWorkGearReport(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseGetMyLastWorkGearReportHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CaseGetMyLastWorkGearReportQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseGetMyLastWorkGearReportHook>>>
>;
export type CaseGetMyLastWorkGearReportQueryError = unknown;

export const useCaseGetMyLastWorkGearReport = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useCaseGetMyLastWorkGearReportHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseGetMyLastWorkGearReportHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useCaseGetMyLastWorkGearReportQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useCaseGetMostRecentClosedCasesHook = () => {
  const caseGetMostRecentClosedCases = useCustomInstance<CaseModel[]>();

  return useCallback(
    (params?: CaseGetMostRecentClosedCasesParams, signal?: AbortSignal) => {
      return caseGetMostRecentClosedCases({
        url: `/api/Case/GetMostRecentClosedCases`,
        method: 'GET',
        params,
        signal,
      });
    },
    [caseGetMostRecentClosedCases]
  );
};

export const getCaseGetMostRecentClosedCasesQueryKey = (
  params?: CaseGetMostRecentClosedCasesParams
) => {
  return [
    `/api/Case/GetMostRecentClosedCases`,
    ...(params ? [params] : []),
  ] as const;
};

export const useCaseGetMostRecentClosedCasesQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useCaseGetMostRecentClosedCasesHook>>
  >,
  TError = unknown,
>(
  params?: CaseGetMostRecentClosedCasesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useCaseGetMostRecentClosedCasesHook>>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCaseGetMostRecentClosedCasesQueryKey(params);

  const caseGetMostRecentClosedCases = useCaseGetMostRecentClosedCasesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseGetMostRecentClosedCasesHook>>>
  > = ({ signal }) => caseGetMostRecentClosedCases(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseGetMostRecentClosedCasesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CaseGetMostRecentClosedCasesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseGetMostRecentClosedCasesHook>>>
>;
export type CaseGetMostRecentClosedCasesQueryError = unknown;

export const useCaseGetMostRecentClosedCases = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useCaseGetMostRecentClosedCasesHook>>
  >,
  TError = unknown,
>(
  params?: CaseGetMostRecentClosedCasesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useCaseGetMostRecentClosedCasesHook>>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useCaseGetMostRecentClosedCasesQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useCaseGetCasesHook = () => {
  const caseGetCases = useCustomInstance<BasicCaseModel[]>();

  return useCallback(
    (getAllCasesRequest: GetAllCasesRequest) => {
      return caseGetCases({
        url: `/api/Case/GetCases`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: getAllCasesRequest,
      });
    },
    [caseGetCases]
  );
};

export const useCaseGetCasesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseGetCasesHook>>>,
    TError,
    { data: GetAllCasesRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCaseGetCasesHook>>>,
  TError,
  { data: GetAllCasesRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const caseGetCases = useCaseGetCasesHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseGetCasesHook>>>,
    { data: GetAllCasesRequest }
  > = (props) => {
    const { data } = props ?? {};

    return caseGetCases(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaseGetCasesMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseGetCasesHook>>>
>;
export type CaseGetCasesMutationBody = GetAllCasesRequest;
export type CaseGetCasesMutationError = unknown;

export const useCaseGetCases = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseGetCasesHook>>>,
    TError,
    { data: GetAllCasesRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCaseGetCasesHook>>>,
  TError,
  { data: GetAllCasesRequest },
  TContext
> => {
  const mutationOptions = useCaseGetCasesMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCaseGetRecentDuplicateCaseHook = () => {
  const caseGetRecentDuplicateCase =
    useCustomInstance<RecentDuplicateCaseResult>();

  return useCallback(
    (params?: CaseGetRecentDuplicateCaseParams, signal?: AbortSignal) => {
      return caseGetRecentDuplicateCase({
        url: `/api/Case/GetRecentDuplicateCase`,
        method: 'GET',
        params,
        signal,
      });
    },
    [caseGetRecentDuplicateCase]
  );
};

export const getCaseGetRecentDuplicateCaseQueryKey = (
  params?: CaseGetRecentDuplicateCaseParams
) => {
  return [
    `/api/Case/GetRecentDuplicateCase`,
    ...(params ? [params] : []),
  ] as const;
};

export const useCaseGetRecentDuplicateCaseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useCaseGetRecentDuplicateCaseHook>>
  >,
  TError = unknown,
>(
  params?: CaseGetRecentDuplicateCaseParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useCaseGetRecentDuplicateCaseHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCaseGetRecentDuplicateCaseQueryKey(params);

  const caseGetRecentDuplicateCase = useCaseGetRecentDuplicateCaseHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useCaseGetRecentDuplicateCaseHook>>>
  > = ({ signal }) => caseGetRecentDuplicateCase(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCaseGetRecentDuplicateCaseHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CaseGetRecentDuplicateCaseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCaseGetRecentDuplicateCaseHook>>>
>;
export type CaseGetRecentDuplicateCaseQueryError = unknown;

export const useCaseGetRecentDuplicateCase = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useCaseGetRecentDuplicateCaseHook>>
  >,
  TError = unknown,
>(
  params?: CaseGetRecentDuplicateCaseParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useCaseGetRecentDuplicateCaseHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useCaseGetRecentDuplicateCaseQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
